// apps/web/src/features/russia-requests/components/tabs/ItemsTab.tsx
//
// Read-only items tab — renders `RussiaRequest.items` as per-position cards
// (#1578). Cards replace the legacy flat table so that description, brand,
// and productQuantity are visible in the drawer.
// Editing remains out of scope for this slice (per #706 `## Out of scope`).

import { useTranslation } from 'react-i18next';
import type { RussiaRequest } from '@magimp/shared';

import { RussiaPositionCard } from './RussiaPositionCard.js';

export function ItemsTab({ request }: { request: RussiaRequest }) {
  const { t } = useTranslation('russiaRequests');
  if (request.items.length === 0) {
    return (
      <p
        data-testid="russia-request-drawer-items-empty"
        style={{ color: 'var(--fg-3)', fontSize: 13, margin: 0 }}
      >
        {t('drawer.items.empty')}
      </p>
    );
  }
  return (
    <div
      data-testid="russia-request-drawer-items-table"
      style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
    >
      {request.items.map((item) => (
        <RussiaPositionCard key={item.id} requestId={request.id} item={item} />
      ))}
    </div>
  );
}
